import { render } from "./RegisterNotificationTemplate.vue?vue&type=template&id=fe04a4aa&scoped=true"
import script from "./RegisterNotificationTemplate.js?vue&type=script&lang=js"
export * from "./RegisterNotificationTemplate.js?vue&type=script&lang=js"

import "./RegisterNotificationTemplate.scss?vue&type=style&index=0&id=fe04a4aa&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe04a4aa"]])

export default __exports__